import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { MdCloseFullscreen } from "react-icons/md";
import profile from "../../../../Assets/5856.jpg"
import { Baseurl } from '../../../../Api/Baseurl';
import { toast } from 'react-toastify';
import { ToastOptions } from '../../../../helpers/ToastOptions';
import { MdAdd, MdEdit, MdDelete, MdExpandMore, MdExpandLess, MdAccessTime, MdBook, MdCalendarToday, MdUpdate, MdViewList, MdFolderOpen, MdPlayCircleFilled, MdDragIndicator, MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md';
import { useQuery } from 'react-query';
import { motion } from 'framer-motion';
import './CourseContent.scss';
import './section-drag-handle.scss';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import CourseResources from './CourseResources';
import BackButton from '../../../../components/Backbutton/BackButton';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DnDProvider, DraggableItem, DropTarget, useReorder, useDraggableItem, useDnD, ENTITY_TYPES, SCOPE_TYPES } from '../../../../components/DnD';


// Inner component that uses DnD hooks
const CourseContentInner = ({ courseData, courseRefetch }) => {
    const { courseId } = useParams();
    const [expandedSections, setExpandedSections] = useState({});
    const [expandedChapters, setExpandedChapters] = useState({});

    // Form states
    const [showAddSection, setShowAddSection] = useState(false);
    const [showAddChapter, setShowAddChapter] = useState(false);
    const [showAddLecture, setShowAddLecture] = useState(false);
    const [selectedSectionId, setSelectedSectionId] = useState(null);
    const [selectedChapterId, setSelectedChapterId] = useState(null);
    const [showEditLecture, setShowEditLecture] = useState(false);
    const [topicNotificationPopup, setTopicNotificationPopup] = useState(false);
    const [editLectureForm, setEditLectureForm] = useState({
        id: '',
        title: '',
        description: '',
        lecNumber: '',
        duration: '',
        lecVideo: '',
        videoYoutube: '',
        accountId: '',
        videotype: 'both',
        lecThumb: null
    });

    // Section Edit State
    const [showEditSection, setShowEditSection] = useState(false);
    const [editSectionForm, setEditSectionForm] = useState({
        id: '',
        name: ''
    });

    // Chapter Edit State
    const [showEditChapter, setShowEditChapter] = useState(false);
    const [editChapterForm, setEditChapterForm] = useState({
        id: '',
        title: ''
    });

    const [Accounts, setAccounts] = useState([]);
    const token = localStorage.getItem('medtoken');

    // Quality settings state
    const [qualitySettings, setQualitySettings] = useState({
        quality_240p: false,
        quality_360p: false,
        quality_480p: false,
        quality_540p: false,
        quality_720p: false
    });

    // Add this state with other states
    const [activeTab, setActiveTab] = useState('lectures');

    // Add separate state for edit lecture modal tabs
    const [editModalTab, setEditModalTab] = useState('main');

    // Video type bulk update states
    const [selectedLectures, setSelectedLectures] = useState([]);
    const [showVideoTypeModal, setShowVideoTypeModal] = useState(false);
    const [videoTypeForm, setVideoTypeForm] = useState({
        videotype: 'both'
    });

    // Table of Contents states
    const [showTableOfContents, setShowTableOfContents] = useState(false);
    const [expandedTocSections, setExpandedTocSections] = useState({});
    const [expandedTocChapters, setExpandedTocChapters] = useState({});

    // Drag and drop states are now handled by DnDProvider

    // courseData and courseRefetch are now passed as props

    const openTopicNotificationPopup = () => {
        setTopicNotificationPopup(true);
    };
    const closeTopicNotificationPopup = () => {
        setTopicNotificationPopup(false);
        topicNotificationFormik.resetForm();
    };


    // Topic notification formik and handlers
    const topicNotificationValidation = Yup.object({
        title: Yup.string().required('Title is required'),
        message: Yup.string().required('Message is required'),
        redirectTo: Yup.string(),
    });

    const topicNotificationFormik = useFormik({
        initialValues: {
            topic: `course_${courseId}`,
            title: '',
            message: '',
            redirectTo: '',
        },
        validationSchema: topicNotificationValidation,
        onSubmit: async (values) => {
            console.log(values);
            try {
                const response = await axios.post(`${Baseurl}/admin/notifications/send-topic`, {
                    topic: values.topic,
                    title: values.title,
                    message: values.message,
                    type: 'topic',
                    contentId: '',
                    redirectTo: values.redirectTo || "home",
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                const { fcmSent } = response.data.payload;

                if (fcmSent) {
                    toast.success(`Notification sent successfully}`, ToastOptions('success'));
                } else {
                    toast.success('Notification sent successfully', ToastOptions('success'));
                }
                closeTopicNotificationPopup();
            } catch (error) {
                console.error('Topic notification error:', error);
                if (error.response?.data?.message) {
                    toast.error(error.response.data.message, ToastOptions('error'));
                } else {
                    toast.error('Failed to send topic notification', ToastOptions('error'));
                }
            }
        },
    });
    // Toggle section expansion
    const toggleSection = (sectionId) => {
        setExpandedSections(prev => ({
            ...prev,
            [sectionId]: !prev[sectionId]
        }));
    };

    // Toggle chapter expansion
    const toggleChapter = (chapterId) => {
        setExpandedChapters(prev => ({
            ...prev,
            [chapterId]: !prev[chapterId]
        }));
    };

    // Table of Contents functions
    const toggleTocSection = (sectionId) => {
        setExpandedTocSections(prev => ({
            ...prev,
            [sectionId]: !prev[sectionId]
        }));
    };

    const toggleTocChapter = (chapterId) => {
        setExpandedTocChapters(prev => ({
            ...prev,
            [chapterId]: !prev[chapterId]
        }));
    };

    const navigateToSection = (sectionId) => {
        setExpandedSections(prev => ({ ...prev, [sectionId]: true }));
        setShowTableOfContents(false);
        // Scroll to section
        const sectionElement = document.querySelector(`[data-section-id="${sectionId}"]`);
        if (sectionElement) {
            sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const navigateToChapter = (sectionId, chapterId) => {
        setExpandedSections(prev => ({ ...prev, [sectionId]: true }));
        setExpandedChapters(prev => ({ ...prev, [chapterId]: true }));
        setShowTableOfContents(false);
        // Scroll to chapter
        const chapterElement = document.querySelector(`[data-chapter-id="${chapterId}"]`);
        if (chapterElement) {
            chapterElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const navigateToLecture = (sectionId, chapterId, lectureId) => {
        setExpandedSections(prev => ({ ...prev, [sectionId]: true }));
        setExpandedChapters(prev => ({ ...prev, [chapterId]: true }));
        setShowTableOfContents(false);
        // Scroll to lecture
        const lectureElement = document.querySelector(`[data-lecture-id="${lectureId}"]`);
        if (lectureElement) {
            lectureElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    // Calculate course statistics
    const getCourseStats = () => {
        if (!courseData.sections) return { sections: 0, chapters: 0, lectures: 0, totalDuration: 0 };

        let totalChapters = 0;
        let totalLectures = 0;
        let totalDuration = 0;

        courseData.sections.forEach(section => {
            if (section.chapters) {
                totalChapters += section.chapters.length;
                section.chapters.forEach(chapter => {
                    if (chapter.lectures) {
                        totalLectures += chapter.lectures.length;
                        chapter.lectures.forEach(lecture => {
                            if (lecture.duration) {

                                const durationParts = lecture.duration.split(':');
                                if (durationParts.length === 3) {
                                    totalDuration += parseInt(durationParts[0]) * 3600 +
                                        parseInt(durationParts[1]) * 60 +
                                        parseInt(durationParts[2]);
                                } else if (durationParts.length === 2) {
                                    totalDuration += parseInt(durationParts[0]) * 60 +
                                        parseInt(durationParts[1]);
                                }
                            }
                        });
                    }
                });
            }
        });

        const hours = Math.floor(totalDuration / 3600);
        const minutes = Math.floor((totalDuration % 3600) / 60);
        const seconds = totalDuration % 60;

        return {
            sections: courseData.sections.length,
            chapters: totalChapters,
            lectures: totalLectures,
            totalDuration: `${hours}h ${minutes}m ${seconds}s`
        };
    };

    useEffect(() => {
        getAccounts();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const getAccounts = async () => {
        try {
            const response = await axios.get(`${Baseurl}/admin/getAllAcounts`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setAccounts(response?.data?.payload?.accounts || []);
        } catch (error) {
            toast.error('Failed to fetch accounts', ToastOptions('error'));
        }
    };

    // Reorder hooks for different entity types
    const sectionReorder = useReorder(ENTITY_TYPES.SECTION, SCOPE_TYPES.COURSE, courseId);
    const chapterReorder = useReorder(ENTITY_TYPES.CHAPTER, SCOPE_TYPES.COURSE, courseId);
    const lectureReorder = useReorder(ENTITY_TYPES.LECTURE, SCOPE_TYPES.CHAPTER);
    
    // Transfer functionality
    const { handleTransfer } = useDnD();


    // Section Formik
    const sectionValidation = Yup.object({
        name: Yup.string().required('Section name is required'),
    });
    const sectionFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: '',
        },
        validationSchema: sectionValidation,
        onSubmit: async (values, { resetForm }) => {
            try {
                await axios.post(`${Baseurl}/admin/sections`, {
                    courseId,
                    ...values
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                toast.success('Section added successfully', ToastOptions('success'));
                setShowAddSection(false);
                resetForm();
                courseRefetch();
            } catch (error) {
                toast.error('Failed to add section', ToastOptions('error'));
            }
        },
    });

    // Chapter Formik
    const chapterValidation = Yup.object({
        title: Yup.string().required('Chapter title is required'),
    });
    const chapterFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: '',
        },
        validationSchema: chapterValidation,
        onSubmit: async (values, { resetForm }) => {
            try {
                await axios.post(`${Baseurl}/admin/chapters`, {
                    sectionId: selectedSectionId,
                    courseId,
                    ...values
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                toast.success('Chapter added successfully', ToastOptions('success'));
                setShowAddChapter(false);
                resetForm();
                courseRefetch();
            } catch (error) {
                toast.error('Failed to add chapter', ToastOptions('error'));
            }
        },
    });




    // Add Lecture Formik
    const lectureValidation = Yup.object({
        title: Yup.string().required('Title is required'),
        description: Yup.string().required('Description is required'),
        lecThumb: Yup.mixed().nullable(),
        lecVideo: Yup.string().nullable(),
        videoYoutube: Yup.string().nullable(),
        duration: Yup.string().required('Duration is required'),
        accountId: Yup.string().required('Account is required'),
        videotype: Yup.string().required('Video type is required').oneOf(['youtube', 'vimeo', 'both'], 'Invalid video type'),
    });
    const lectureFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: '',
            description: '',
            lecThumb: null,
            lecVideo: '',
            videoYoutube: '',
            duration: '',
            durationHours: '',
            durationMinutes: '',
            durationSeconds: '',
            accountId: '',
            videotype: 'both',
        },
        validationSchema: lectureValidation,
        onSubmit: async (values, { resetForm }) => {
            // Check if at least one video URL is provided
            const hasVimeo = values.lecVideo && values.lecVideo.trim() !== '';
            const hasYouTube = values.videoYoutube && values.videoYoutube.trim() !== '';

            if (!hasVimeo && !hasYouTube) {
                toast.error('At least one video URL is required', ToastOptions('error'));
                return;
            }

            const formData = new FormData();
            formData.append('title', values.title);
            formData.append('description', values.description);
            formData.append('lecVideo', values.lecVideo || '');
            formData.append('videoYoutube', values.videoYoutube || '');
            formData.append('duration', values.duration);
            formData.append('accountId', values.accountId);
            formData.append('videotype', values.videotype);
            formData.append('courseId', courseId);
            formData.append('chapterId', selectedChapterId);

            if (values.lecThumb) {
                formData.append('lectures', values.lecThumb);
            }

            try {
                const response = await axios.post(`${Baseurl}/admin/courses/addLecture`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (response.data) {
                    toast.success('Lecture added successfully', ToastOptions('success'));
                    setShowAddLecture(false);
                    resetForm();
                    courseRefetch();
                }
            } catch (error) {
                console.error('Error adding lecture:', error);
                toast.error(error.response?.data?.msg || 'Failed to add lecture', ToastOptions('error'));
            }
        },
    });





    // Edit Lecture Formik
    const editLectureValidation = Yup.object({
        title: Yup.string().required('Title is required'),
        description: Yup.string().required('Description is required'),
        lecVideo: Yup.string().nullable(),
        videoYoutube: Yup.string().nullable(),
        duration: Yup.string().required('Duration is required'),
        accountId: Yup.string().required('Account is required'),
        videotype: Yup.string().required('Video type is required').oneOf(['youtube', 'vimeo', 'both'], 'Invalid video type'),
        lecThumb: Yup.mixed().nullable()
    });
    const editLectureFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: editLectureForm.title || '',
            description: editLectureForm.description || '',
            lecThumb: null,
            lecVideo: editLectureForm.lecVideo || '',
            videoYoutube: editLectureForm.videoYoutube || '',
            duration: editLectureForm.duration || '',
            editDurationHours: '',
            editDurationMinutes: '',
            editDurationSeconds: '',
            accountId: editLectureForm.accountId || '',
            videotype: editLectureForm.videotype || 'both',
        },
        validationSchema: editLectureValidation,
        onSubmit: async (values, { resetForm }) => {
            // Check if at least one video URL is provided
            const hasVimeo = values.lecVideo && values.lecVideo.trim() !== '';
            const hasYouTube = values.videoYoutube && values.videoYoutube.trim() !== '';

            if (!hasVimeo && !hasYouTube) {
                toast.error('At least one video URL is required', ToastOptions('error'));
                return;
            }

            try {
                const formData = new FormData();

                formData.append('title', values.title);
                formData.append('description', values.description);
                formData.append('lecVideo', values.lecVideo || '');
                formData.append('videoYoutube', values.videoYoutube || '');
                formData.append('duration', values.duration);
                formData.append('accountId', values.accountId);
                formData.append('videotype', values.videotype);
                if (values.lecThumb && values.lecThumb instanceof File) {
                    formData.append('lectures', values.lecThumb);
                }

                const response = await axios.put(
                    `${Baseurl}/admin/lecturesupdate/${editLectureForm.id}`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                if (response.data.success) {
                    toast.success('Lecture updated successfully', ToastOptions('success'));
                    setShowEditLecture(false);
                    setEditLectureForm({
                        id: '',
                        title: '',
                        description: '',
                        lecThumb: null,
                        lecVideo: '',
                        videoYoutube: '',
                        duration: '',
                        accountId: '',
                        videotype: 'both'
                    });
                    resetForm();
                    courseRefetch();
                } else {
                    toast.error(response.data.message || 'Failed to update lecture', ToastOptions('error'));
                }
            } catch (error) {
                console.error('Error updating lecture:', error);
                toast.error(error.response?.data?.message || 'Failed to update lecture', ToastOptions('error'));
            }
        },
    });

    // Section Edit Formik
    const editSectionValidation = Yup.object({
        name: Yup.string().required('Section name is required'),
    });
    const editSectionFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: editSectionForm.name || '',
        },
        validationSchema: editSectionValidation,
        onSubmit: async (values, { resetForm }) => {
            try {
                await axios.put(`${Baseurl}/admin/sections/${editSectionForm.id}`, {
                    name: values.name,
                    courseId
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                toast.success('Section updated successfully', ToastOptions('success'));
                setShowEditSection(false);
                setEditSectionForm({ id: '', name: '' });
                resetForm();
                courseRefetch();
            } catch (error) {
                toast.error('Failed to update section', ToastOptions('error'));
            }
        },
    });

    // Chapter Edit Formik
    const editChapterValidation = Yup.object({
        title: Yup.string().required('Chapter title is required'),
    });
    const editChapterFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: editChapterForm.title || '',
        },
        validationSchema: editChapterValidation,
        onSubmit: async (values, { resetForm }) => {
            try {
                await axios.put(`${Baseurl}/admin/chapters/${editChapterForm.id}`, {
                    title: values.title,
                    sectionId: selectedSectionId
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                toast.success('Chapter updated successfully', ToastOptions('success'));
                setShowEditChapter(false);
                setEditChapterForm({ id: '', title: '' });
                resetForm();
                courseRefetch();
            } catch (error) {
                toast.error('Failed to update chapter', ToastOptions('error'));
            }
        },
    });

    // Delete section
    const handleDeleteSection = async (sectionId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This section and all its contents will be permanently deleted",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#01677e",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (res) => {
            if (res.isConfirmed) {
                try {
                    await axios.delete(`${Baseurl}/admin/sections/${sectionId}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    toast.success('Section deleted successfully', ToastOptions('success'));
                    courseRefetch();
                } catch (error) {
                    toast.error('Failed to delete section', ToastOptions('error'));
                }
            }
        });
    };

    // Delete chapter
    const handleDeleteChapter = async (chapterId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This chapter and all its lectures will be permanently deleted",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#01677e",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (res) => {
            if (res.isConfirmed) {
                try {
                    await axios.delete(`${Baseurl}/admin/chapters/${chapterId}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    toast.success('Chapter deleted successfully', ToastOptions('success'));
                    courseRefetch();
                } catch (error) {
                    toast.error('Failed to delete chapter', ToastOptions('error'));
                }
            }
        });
    };

    // Delete lecture
    const handleDeleteLecture = async (lectureId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This lecture will be permanently deleted",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#01677e",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (res) => {
            if (res.isConfirmed) {
                try {
                    await axios.delete(`${Baseurl}/admin/deleteLecture/${lectureId}`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    toast.success('Lecture deleted successfully', ToastOptions('success'));
                    courseRefetch();
                } catch (error) {
                    toast.error('Failed to delete lecture', ToastOptions('error'));
                }
            }
        });
    };


    useEffect(() => {
        if (showEditLecture && editLectureForm.id) {
            setEditLectureForm((prev) => ({ ...prev }));
        }
    }, [showEditLecture, editLectureForm.id]);


    const handleOpenEditLecture = (lecture) => {
        // Parse duration if it exists
        let durationHours = '';
        let durationMinutes = '';
        let durationSeconds = '';

        if (lecture.duration) {
            // Handle different duration formats
            if (lecture.duration.includes(':')) {
                // Format: HH:MM:SS or MM:SS
                const parts = lecture.duration.split(':');
                if (parts.length === 3) {
                    durationHours = parts[0];
                    durationMinutes = parts[1];
                    durationSeconds = parts[2];
                } else if (parts.length === 2) {
                    durationMinutes = parts[0];
                    durationSeconds = parts[1];
                }
            } else {
                // Handle text format like "2h 30min" or "1h 15min 30sec"
                const hourMatch = lecture.duration.match(/(\d+)\s*h/);
                const minuteMatch = lecture.duration.match(/(\d+)\s*min/);
                const secondMatch = lecture.duration.match(/(\d+)\s*sec/);

                if (hourMatch) durationHours = hourMatch[1];
                if (minuteMatch) durationMinutes = minuteMatch[1];
                if (secondMatch) durationSeconds = secondMatch[1];
            }
        }

        const formData = {
            id: lecture.id || '',
            title: lecture.title || '',
            description: lecture.description || '',
            duration: lecture.duration || '',
            editDurationHours: durationHours,
            editDurationMinutes: durationMinutes,
            editDurationSeconds: durationSeconds,
            lecVideo: lecture.lecVideo || '',
            videoYoutube: lecture.videoYoutube || '',
            accountId: lecture.accountId || '',
            videotype: lecture.videotype || 'both',
            lecThumb: null
        };

        // Set quality settings
        setQualitySettings({
            quality_240p: lecture.quality_240p || false,
            quality_360p: lecture.quality_360p || false,
            quality_480p: lecture.quality_480p || false,
            quality_540p: lecture.quality_540p || false,
            quality_720p: lecture.quality_720p || false
        });

        setEditLectureForm(formData);
        editLectureFormik.setValues(formData);
        setEditModalTab('main');
        setShowEditLecture(true);
    };

    // Section edit open
    const handleOpenEditSection = (section) => {
        setEditSectionForm({
            id: section.id,
            name: section.name
        });
        setShowEditSection(true);
    };

    // Chapter edit open
    const handleOpenEditChapter = (chapter, sectionId) => {
        setEditChapterForm({
            id: chapter.id,
            title: chapter.title
        });
        setSelectedSectionId(sectionId);
        setShowEditChapter(true);
    };

    // Add these functions before the return statement
    const handleQualityToggle = async (lectureId, qualityKey) => {
        try {
            const endpoint = qualitySettings[qualityKey]
                ? `${Baseurl}/admin/qualitydeactiviate/${lectureId}`
                : `${Baseurl}/admin/qualityactive/${lectureId}`;

            const response = await axios.put(endpoint,
                { key: qualityKey },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success) {
                setQualitySettings(prev => ({
                    ...prev,
                    [qualityKey]: !prev[qualityKey]
                }));
                toast.success('Quality setting updated successfully', ToastOptions('success'));
                courseRefetch();
            }
        } catch (error) {
            toast.error('Failed to update quality setting', ToastOptions('error'));
        }
    };

    // Video type bulk update functions
    const handleSelectLecture = (lectureId, checked) => {
        if (checked) {
            setSelectedLectures(prev => [...prev, lectureId]);
        } else {
            setSelectedLectures(prev => prev.filter(id => id !== lectureId));
        }
    };



    const handleBulkUpdateVideoType = async () => {
        if (selectedLectures.length === 0) {
            toast.error("Please select lectures to update", ToastOptions("error"));
            return;
        }

        try {
            const response = await axios.put(`${Baseurl}/admin/lectures/video-type/bulk`, {
                lectureIds: selectedLectures,
                videotype: videoTypeForm.videotype
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            toast.success(response.data.msg, ToastOptions("success"));
            setSelectedLectures([]);
            setShowVideoTypeModal(false);
            courseRefetch();
        } catch (error) {
            toast.error(error.response?.data?.msg || "Failed to update video types", ToastOptions("error"));
        }
    };

    const getVideoTypeBadge = (videotype) => {
        const types = {
            youtube: {
                label: 'YouTube + (Player 1)',
                className: 'video-type-badge bg-red-50 text-red-700 border border-red-200'
            },
            vimeo: {
                label: 'Vimeo + (Player 2)',
                className: 'video-type-badge bg-blue-50 text-blue-700 border border-blue-200'
            },
            both: {
                label: 'Both Players',
                className: 'video-type-badge bg-green-50 text-green-700 border border-green-200'
            }
        };

        const type = types[videotype] || types.both;
        return (
            <span className={type.className}>
                {type.label}
            </span>
        );
    };

    useEffect(() => {
        if (courseData.sections) {
            const expanded = {};
            courseData.sections.forEach(section => {
                // Preserve existing expansion state or set to false for new sections
                expanded[section.id] = expandedSections[section.id] !== undefined ? expandedSections[section.id] : false;
            });
            setExpandedSections(expanded);
        }
    }, [courseData.sections]); // eslint-disable-line react-hooks/exhaustive-deps

    // Preserve chapter expansion states when data changes
    useEffect(() => {
        if (courseData.sections) {
            const expanded = {};
            courseData.sections.forEach(section => {
                if (section.chapters) {
                    section.chapters.forEach(chapter => {
                        // Preserve existing expansion state or set to false for new chapters
                        expanded[chapter.id] = expandedChapters[chapter.id] !== undefined ? expandedChapters[chapter.id] : false;
                    });
                }
            });
            setExpandedChapters(expanded);
        }
    }, [courseData.sections]); // eslint-disable-line react-hooks/exhaustive-deps

    // Drag and Drop Components using reusable components
    const SectionDragItem = ({ section, index }) => {
        const { drag } = useDraggableItem('section', section, index);
        const { handleMoveToEnd, handleMoveToBeginning } = useDnD();
        
        const handleReorder = async (draggedItem, targetIndex) => {
            if (draggedItem.index !== targetIndex) {
                await sectionReorder.reorder(draggedItem, targetIndex, SCOPE_TYPES.COURSE, courseId, courseData.sections);
                courseRefetch();
            }
        };

        const handleMoveToTop = async () => {
            try {
                await handleMoveToBeginning(ENTITY_TYPES.SECTION, section.id, SCOPE_TYPES.COURSE, courseId);
                courseRefetch();
            } catch (error) {
                console.error('Error moving section to top:', error);
                toast.error('Failed to move section to top', ToastOptions('error'));
            }
        };

        const handleMoveToBottom = async () => {
            try {
                await handleMoveToEnd(ENTITY_TYPES.SECTION, section.id, SCOPE_TYPES.COURSE, courseId);
                courseRefetch();
            } catch (error) {
                console.error('Error moving section to bottom:', error);
                toast.error('Failed to move section to bottom', ToastOptions('error'));
            }
        };

        return (
            <DraggableItem
                type="section"
                item={section}
                index={index}
                className="section-item"
                showDragHandle={false}
                onDragEnd={(draggedItem, monitor) => {
                    if (monitor.didDrop()) {
                        const dropResult = monitor.getDropResult();
                        if (dropResult && dropResult.index !== undefined) {
                            handleReorder(draggedItem, dropResult.index, section.chapters);
                        }
                    }
                }}
            >
                <div className="section-header">
                    <div className="section-title" onClick={() => toggleSection(section.id)}>
                        {expandedSections[section.id] ? <MdExpandLess /> : <MdExpandMore />}
                        <h3>{section.name}</h3>
                    </div>
                    <div className="section-actions">
                        <button onClick={() => {
                            setSelectedSectionId(section.id);
                            setShowAddChapter(true);
                        }}>
                            <MdAdd /> Add Chapter
                        </button>
                        <div 
                            ref={drag} 
                            className="section-drag-handle"
                            onMouseDown={(e) => e.stopPropagation()}
                            onTouchStart={(e) => e.stopPropagation()}
                        >
                            <MdDragIndicator />
                        </div>
                        <button 
                            onClick={handleMoveToTop}
                            className="move-btn move-top"
                            title="Move to Top"
                        >
                            <MdKeyboardArrowUp />
                        </button>
                        <button 
                            onClick={handleMoveToBottom}
                            className="move-btn move-bottom"
                            title="Move to Bottom"
                        >
                            <MdKeyboardArrowDown />
                        </button>
                        <button onClick={() => handleOpenEditSection(section)}>
                            <MdEdit />
                        </button>
                        <button onClick={() => handleDeleteSection(section.id)}>
                            <MdDelete />
                        </button>
                    </div>
                </div>

                {/* Chapters List */}
                {expandedSections[section.id] && (
                    <div className="chapters-list">
                        {section.chapters?.map((chapter, chapterIndex) => (
                            <DropTarget
                                key={chapter.id}
                                acceptTypes={["chapter", "lecture"]}
                                targetItemId={chapter.id}
                                onDrop={(item, monitor) => {
                                    if (item.type === 'chapter' && item.id !== chapter.id) {
                                        chapterReorder.reorder(item, chapterIndex, SCOPE_TYPES.COURSE, courseId, section.chapters);
                                        courseRefetch();
                                    } else if (item.type === 'lecture') {
                                        // Handle lecture transfer to this chapter
                                        handleTransfer(ENTITY_TYPES.LECTURE, item.id, ENTITY_TYPES.CHAPTER, chapter.id);
                                        courseRefetch();
                                    }
                                }}
                            >
                                <ChapterDragItem
                                chapter={chapter}
                                sectionId={section.id}
                                index={chapterIndex}
                                chaptersArray={section.chapters}
                            />
                            </DropTarget>
                        ))}
                    </div>
                )}
            </DraggableItem>
        );
    };

    const SectionDropTarget = ({ children, onDrop, targetItemId = null }) => {
        return (
            <DropTarget
                acceptTypes={["section", "chapter"]}
                onDrop={onDrop}
                targetItemId={targetItemId}
                className="section-drop-target"
            >
                {children}
            </DropTarget>
        );
    };

    const ChapterDragItem = ({ chapter, sectionId, index, chaptersArray }) => {
        const { drag } = useDraggableItem('chapter', chapter, index);
        const { handleMoveToEnd, handleMoveToBeginning } = useDnD();
        
        const handleReorder = async (draggedItem, targetIndex, chaptersArray) => {
            if (draggedItem.index !== targetIndex) {
                await chapterReorder.reorder(draggedItem, targetIndex, SCOPE_TYPES.COURSE, courseId, chaptersArray);
                courseRefetch();
            }
        };

        const handleMoveToTop = async () => {
            try {
                await handleMoveToBeginning(ENTITY_TYPES.CHAPTER, chapter.id, SCOPE_TYPES.COURSE, courseId);
                courseRefetch();
            } catch (error) {
                console.error('Error moving chapter to top:', error);
                toast.error('Failed to move chapter to top', ToastOptions('error'));
            }
        };

        const handleMoveToBottom = async () => {
            try {
                await handleMoveToEnd(ENTITY_TYPES.CHAPTER, chapter.id, SCOPE_TYPES.COURSE, courseId);
                courseRefetch();
            } catch (error) {
                console.error('Error moving chapter to bottom:', error);
                toast.error('Failed to move chapter to bottom', ToastOptions('error'));
            }
        };


        return (
            <DraggableItem
                type="chapter"
                item={chapter}
                index={index}
                className="chapter-item"
                showDragHandle={false}
                onDragEnd={(draggedItem, monitor) => {
                    if (monitor.didDrop()) {
                        const dropResult = monitor.getDropResult();
                        if (dropResult && dropResult.index !== undefined) {
                            handleReorder(draggedItem, dropResult.index, chaptersArray);
                        }
                    }
                }}
            >
                <div className="chapter-header">
                    <div className="chapter-title" onClick={() => toggleChapter(chapter.id)}>
                        {expandedChapters[chapter.id] ? <MdExpandLess /> : <MdExpandMore />}
                        <h4>{chapter.title}</h4>
                    </div>
                    <div className="chapter-actions">
                        {expandedChapters[chapter.id] && chapter.lectures?.length > 0 && (
                            <div className="select-all-container">
                                <input
                                    type="checkbox"
                                    checked={chapter.lectures?.every(lecture => selectedLectures.includes(lecture.id))}
                                    onChange={(e) => {
                                        chapter.lectures?.forEach(lecture => {
                                            handleSelectLecture(lecture.id, e.target.checked);
                                        });
                                    }}
                                    className="select-all-checkbox"
                                />
                                <span className="select-all-text">Select All</span>
                            </div>
                        )}
                        <button onClick={() => {
                            setSelectedChapterId(chapter.id);
                            setShowAddLecture(true);
                        }}>
                            <MdAdd /> Add Lecture
                        </button>
                        <div 
                            ref={drag} 
                            className="chapter-drag-handle"
                            onMouseDown={(e) => e.stopPropagation()}
                            onTouchStart={(e) => e.stopPropagation()}
                        >
                            <MdDragIndicator />
                        </div>
                        <button 
                            onClick={handleMoveToTop}
                            className="move-btn move-top"
                            title="Move to Top"
                        >
                            <MdKeyboardArrowUp />
                        </button>
                        <button 
                            onClick={handleMoveToBottom}
                            className="move-btn move-bottom"
                            title="Move to Bottom"
                        >
                            <MdKeyboardArrowDown />
                        </button>
                        <button onClick={() => handleOpenEditChapter(chapter, sectionId)}>
                            <MdEdit />
                        </button>
                        <button onClick={() => handleDeleteChapter(chapter.id)}>
                            <MdDelete />
                        </button>
                    </div>
                </div>

                {/* Lectures List */}
                {expandedChapters[chapter.id] && (
                    <div className="lectures-list">
                        {chapter.lectures?.map((lecture, lectureIndex) => (
                            <DropTarget
                                key={lecture.id}
                                acceptTypes="lecture"
                                targetItemId={lecture.id}
                                onDrop={(item, monitor) => {
                                    if (item.type === 'lecture' && item.id !== lecture.id) {
                                        lectureReorder.reorder(item, lectureIndex, SCOPE_TYPES.CHAPTER, chapter.id, chapter.lectures);
                                    }
                                }}
                            >
                                <LectureDragItem
                                lecture={lecture}
                                chapterId={chapter.id}
                                index={lectureIndex}
                                lecturesArray={chapter.lectures}
                            />
                            </DropTarget>
                        ))}
                    </div>
                )}
            </DraggableItem>
        );
    };

    const LectureDragItem = ({ lecture, chapterId, index, lecturesArray }) => {
        const { drag } = useDraggableItem('lecture', lecture, index);
        const { handleMoveToEnd, handleMoveToBeginning } = useDnD();
        
        const handleReorder = async (draggedItem, targetIndex, lecturesArray) => {
            if (draggedItem.index !== targetIndex) {
                await lectureReorder.reorder(draggedItem, targetIndex, SCOPE_TYPES.CHAPTER, chapterId, lecturesArray);
                courseRefetch();
            }
        };

        const handleMoveToTop = async () => {
            try {
                await handleMoveToBeginning(ENTITY_TYPES.LECTURE, lecture.id, SCOPE_TYPES.CHAPTER, chapterId);
                courseRefetch();
            } catch (error) {
                console.error('Error moving lecture to top:', error);
                toast.error('Failed to move lecture to top', ToastOptions('error'));
            }
        };

        const handleMoveToBottom = async () => {
            try {
                await handleMoveToEnd(ENTITY_TYPES.LECTURE, lecture.id, SCOPE_TYPES.CHAPTER, chapterId);
                courseRefetch();
            } catch (error) {
                console.error('Error moving lecture to bottom:', error);
                toast.error('Failed to move lecture to bottom', ToastOptions('error'));
            }
        };


        return (
            <DraggableItem
                type="lecture"
                item={lecture}
                index={index}
                className="lecture-item"
                showDragHandle={false}
                onDragEnd={(draggedItem, monitor) => {
                    if (monitor.didDrop()) {
                        const dropResult = monitor.getDropResult();
                        if (dropResult && dropResult.index !== undefined) {
                            handleReorder(draggedItem, dropResult.index, lecturesArray);
                        }
                    }
                }}
            >
                <div className="lecture-selection">
                    <input
                        type="checkbox"
                        checked={selectedLectures.includes(lecture.id)}
                        onChange={(e) => handleSelectLecture(lecture.id, e.target.checked)}
                        className="lecture-checkbox"
                    />
                </div>
                <div className="lecture-title">
                    <div className="lecture-header">
                        <h5>{lecture.title}</h5>
                        <div className="lecture-meta">
                            {getVideoTypeBadge(lecture.videotype)}
                        </div>
                        <div className="lecture-actions">
                            <div 
                                ref={drag} 
                                className="lecture-drag-handle"
                                onMouseDown={(e) => e.stopPropagation()}
                                onTouchStart={(e) => e.stopPropagation()}
                            >
                                <MdDragIndicator />
                            </div>
                            <button 
                                onClick={handleMoveToTop}
                                className="move-btn move-top"
                                title="Move to Top"
                            >
                                <MdKeyboardArrowUp />
                            </button>
                            <button 
                                onClick={handleMoveToBottom}
                                className="move-btn move-bottom"
                                title="Move to Bottom"
                            >
                                <MdKeyboardArrowDown />
                            </button>
                            <button onClick={() => handleOpenEditLecture(lecture)}>
                                <MdEdit />
                            </button>
                            <button onClick={() => handleDeleteLecture(lecture.id)}>
                                <MdDelete />
                            </button>
                        </div>
                    </div>
                    <div className="lecture-info">
                        <div className="info-item">
                            <MdBook className="info-icon" />
                            <span>Lecture</span>
                            <span className="info-value">{lecture.lecNumber}</span>
                        </div>
                        <div className="info-item">
                            <MdAccessTime className="info-icon" />
                            <span className="info-value">{lecture.duration}</span>
                        </div>
                        <div className="info-item">
                            <MdCalendarToday className="info-icon" />
                            <span>Created:</span>
                            <span className="info-value">
                                {new Date(lecture.createdAt).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}
                            </span>
                        </div>
                        <div className="info-item">
                            <MdUpdate className="info-icon" />
                            <span>Updated:</span>
                            <span className="info-value">
                                {new Date(lecture.updatedAt).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}
                            </span>
                        </div>
                    </div>
                    <div className="lecture-description">
                        {lecture.description}
                    </div>
                    </div>
            </DraggableItem>
        );
    };

    return (
            <div className="course-content">
            <div className="content-header">
                <div className="header-top">
                    <BackButton />
                    <div className="header-actions">
                        <button
                            className="toc-btn"
                            onClick={() => setShowTableOfContents(true)}
                            title="Table of Contents"
                        >
                            <MdBook /> Index
                        </button>
                        <button
                            className="add-section-btn"
                            onClick={() => setShowAddSection(true)}
                        >
                            <MdAdd /> Add Section
                        </button>
                    </div>
                </div>
                <div className="course-info">
                    <h2>{courseData.name}</h2>
                    <p>{courseData.description}</p>
                    <p>Grade: {courseData.grade}</p>
                    <p>Teacher: {courseData.teacher?.name}</p>
                </div>
            </div>

            {/* Bulk Actions for Video Type */}
            {selectedLectures.length > 0 && (
                <motion.div
                    className="bulk-actions-section"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                >
                    <div className="bulk-actions-content">
                        <div className="selected-count">
                            <span className="font-medium">{selectedLectures.length}</span> lecture(s) selected
                        </div>
                        <div className="bulk-actions-buttons">
                            <button
                                onClick={() => setShowVideoTypeModal(true)}
                                className="bulk-action-btn update-btn"
                            >
                                Update Video Type
                            </button>
                            <button
                                onClick={() => setSelectedLectures([])}
                                className="bulk-action-btn clear-btn"
                            >
                                Clear Selection
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
            < div className="add" style={{ marginBottom: '20px' }} >
                <button onClick={openTopicNotificationPopup}>
                    Send Notification to All Students
                </button>
            </ div>


            <div className="content-tabs" >
                <button
                    className={`tab-button ${activeTab === 'lectures' ? 'active' : ''}`}
                    onClick={() => setActiveTab('lectures')}
                >
                    Lectures
                </button>
                <button
                    className={`tab-button ${activeTab === 'qbanks' ? 'active' : ''}`}
                    onClick={() => setActiveTab('qbanks')}
                >
                    Qbanks
                </button>
                <button
                    className={`tab-button ${activeTab === 'files' ? 'active' : ''}`}
                    onClick={() => setActiveTab('files')}
                >
                    Files
                </button>
                <button
                    className={`tab-button ${activeTab === 'flashcards' ? 'active' : ''}`}
                    onClick={() => setActiveTab('flashcards')}
                >
                    Flashcards
                </button>
            </div>

            {activeTab === 'lectures' ? (
                <>
                    {/* Sections List */}
                    <div className="sections-list">
                        {/* Drop target for moving items to the very top */}
                        <SectionDropTarget
                            targetItemId={courseData.sections && courseData.sections.length > 0 ? courseData.sections[0].id : null}
                            onDrop={(item, monitor) => {
                                    if (item.type === 'section') {
                                        // Move to position 0 (top)
                                        sectionReorder.reorder(item, 0, SCOPE_TYPES.COURSE, courseId, courseData.sections);
                                }
                            }}
                        >
                            <div className="drop-target-top" style={{ 
                                height: '10px', 
                                marginBottom: '5px',
                                border: 'none',
                                borderRadius: '4px',
                                transition: 'all 0.2s ease',
                                opacity: 0
                            }}>
                            </div>
                        </SectionDropTarget>
                        
                        {courseData.sections?.map((section, index) => (
                            <SectionDropTarget
                                key={section.id}
                                targetItemId={section.id}
                                onDrop={(item, monitor) => {
                                    if (item.type === 'section' && item.id !== section.id) {
                                        // Handle section reordering - pass the target index directly
                                        sectionReorder.reorder(item, index, SCOPE_TYPES.COURSE, courseId, courseData.sections);
                                    } else if (item.type === 'chapter') {
                                        // Handle chapter transfer to this section
                                        handleTransfer(ENTITY_TYPES.CHAPTER, item.id, ENTITY_TYPES.SECTION, section.id);
                                        courseRefetch();
                                    }
                                }}
                            >
                                <SectionDragItem section={section} index={index} />
                            </SectionDropTarget>
                        ))}

                        {topicNotificationPopup && (
                            <>
                                <div onClick={closeTopicNotificationPopup} className="back-drop"></div>
                                <div className="popup apperdetails">
                                    <MdCloseFullscreen className='closedetails' onClick={closeTopicNotificationPopup} />
                                    <div className="profile">
                                        <div className="img" style={{
                                            backgroundImage: `url(${profile})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            width: '120px',
                                            height: '120px'
                                        }}>
                                        </div>
                                        <h3 className="text-lg font-semibold mb-4 text-center notification-title">Send Topic Notification</h3>
                                        <form onSubmit={topicNotificationFormik.handleSubmit} className="mx-auto justify-between items-center notification-form">
                                            <div className="mb-5 teachfield">
                                                <label htmlFor="title" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Title</label>
                                                <input
                                                    type="text"
                                                    id="title"
                                                    name="title"
                                                    value={topicNotificationFormik.values.title}
                                                    onBlur={topicNotificationFormik.handleBlur}
                                                    onChange={topicNotificationFormik.handleChange}
                                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                                    placeholder="Notification Title"
                                                    required
                                                />
                                                {topicNotificationFormik.touched.title && topicNotificationFormik.errors.title && (
                                                    <div className="error-message">{topicNotificationFormik.errors.title}</div>
                                                )}
                                            </div>
                                            <div className="mb-5 teachfield">
                                                <label htmlFor="message" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Message</label>
                                                <textarea
                                                    id="message"
                                                    name="message"
                                                    value={topicNotificationFormik.values.message}
                                                    onBlur={topicNotificationFormik.handleBlur}
                                                    onChange={topicNotificationFormik.handleChange}
                                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                                    placeholder="Notification Message"
                                                    rows="3"
                                                    required
                                                />
                                                {topicNotificationFormik.touched.message && topicNotificationFormik.errors.message && (
                                                    <div className="error-message">{topicNotificationFormik.errors.message}</div>
                                                )}
                                            </div>
                                            <div className="mb-5 teachfield">
                                                <label htmlFor="redirectTo" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Redirect To (Optional)</label>
                                                <input
                                                    type="text"
                                                    id="redirectTo"
                                                    name="redirectTo"
                                                    value={topicNotificationFormik.values.redirectTo}
                                                    onBlur={topicNotificationFormik.handleBlur}
                                                    onChange={topicNotificationFormik.handleChange}
                                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                                    placeholder="Redirect URL"
                                                />
                                            </div>
                                            <button type="submit" className="text-white focus:ring-blue-300 font-medium px-5 py-2.5 text-center w-full">Send Topic Notification</button>
                                        </form>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    {/* Add Section Modal */}
                    {showAddSection && (
                        <div className="modal" onClick={() => setShowAddSection(false)}>
                            <div className="modal-content" onClick={e => e.stopPropagation()}>
                                <h3>Add New Section</h3>
                                <form onSubmit={sectionFormik.handleSubmit}>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Section Name"
                                        value={sectionFormik.values.name}
                                        onChange={sectionFormik.handleChange}
                                        onBlur={sectionFormik.handleBlur}
                                    />
                                    {sectionFormik.touched.name && sectionFormik.errors.name && (
                                        <div className="error">{sectionFormik.errors.name}</div>
                                    )}
                                    <div className="modal-actions">
                                        <button type="submit">Add Section</button>
                                        <button type="button" onClick={() => setShowAddSection(false)}>Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {/* Add Chapter Modal */}
                    {showAddChapter && (
                        <div className="modal" onClick={() => setShowAddChapter(false)}>
                            <div className="modal-content" onClick={e => e.stopPropagation()}>
                                <h3>Add New Chapter</h3>
                                <form onSubmit={chapterFormik.handleSubmit}>
                                    <input
                                        type="text"
                                        name="title"
                                        placeholder="Chapter Title"
                                        value={chapterFormik.values.title}
                                        onChange={chapterFormik.handleChange}
                                        onBlur={chapterFormik.handleBlur}
                                    />
                                    {chapterFormik.touched.title && chapterFormik.errors.title && (
                                        <div className="error">{chapterFormik.errors.title}</div>
                                    )}
                                    <div className="modal-actions">
                                        <button type="submit">Add Chapter</button>
                                        <button type="button" onClick={() => setShowAddChapter(false)}>Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {/* Add Lecture Modal */}
                    {showAddLecture && (
                        <div className="modal" onClick={() => setShowAddLecture(false)}>
                            <div className="modal-content" onClick={e => e.stopPropagation()}>
                                <h3>Add New Lecture</h3>
                                <form onSubmit={lectureFormik.handleSubmit}>
                                    <div className="mb-5 studentfield">
                                        <label
                                            htmlFor="title"
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Lecture Title *
                                        </label>
                                        <input
                                            type="text"
                                            id="title"
                                            name="title"
                                            placeholder="Enter lecture title"
                                            value={lectureFormik.values.title}
                                            onChange={lectureFormik.handleChange}
                                            onBlur={lectureFormik.handleBlur}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                        />
                                        {lectureFormik.touched.title && lectureFormik.errors.title && (
                                            <div className="error-text">{lectureFormik.errors.title}</div>
                                        )}
                                    </div>

                                    <div className="mb-5 studentfield">
                                        <label
                                            htmlFor="description"
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Lecture Description *
                                        </label>
                                        <textarea
                                            id="description"
                                            name="description"
                                            placeholder="Enter lecture description"
                                            value={lectureFormik.values.description}
                                            onChange={lectureFormik.handleChange}
                                            onBlur={lectureFormik.handleBlur}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                            rows="3"
                                        />
                                        {lectureFormik.touched.description && lectureFormik.errors.description && (
                                            <div className="error-text">{lectureFormik.errors.description}</div>
                                        )}
                                    </div>

                                    <div className="mb-5 studentfield">
                                        <label
                                            htmlFor="lecThumb"
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Lecture Thumbnail
                                        </label>
                                        <input
                                            type="file"
                                            id="lecThumb"
                                            name="lecThumb"
                                            accept="image/*"
                                            onChange={e => lectureFormik.setFieldValue('lecThumb', e.target.files[0])}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                        />
                                        {lectureFormik.touched.lecThumb && lectureFormik.errors.lecThumb && (
                                            <div className="error-text">{lectureFormik.errors.lecThumb}</div>
                                        )}
                                    </div>

                                    <div className="mb-5 studentfield">
                                        <label
                                            htmlFor="lecVideo"
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Vimeo URL
                                        </label>
                                        <input
                                            type="text"
                                            id="lecVideo"
                                            name="lecVideo"
                                            placeholder="Enter Vimeo video URL"
                                            value={lectureFormik.values.lecVideo}
                                            onChange={lectureFormik.handleChange}
                                            onBlur={lectureFormik.handleBlur}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                        />
                                        {lectureFormik.touched.lecVideo && lectureFormik.errors.lecVideo && (
                                            <div className="error-text">{lectureFormik.errors.lecVideo}</div>
                                        )}
                                    </div>

                                    <div className="mb-5 studentfield">
                                        <label
                                            htmlFor="videoYoutube"
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            YouTube Video URL
                                        </label>
                                        <input
                                            type="text"
                                            id="videoYoutube"
                                            name="videoYoutube"
                                            placeholder="Enter YouTube video URL"
                                            value={lectureFormik.values.videoYoutube}
                                            onChange={lectureFormik.handleChange}
                                            onBlur={lectureFormik.handleBlur}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                        />
                                        {lectureFormik.touched.videoYoutube && lectureFormik.errors.videoYoutube && (
                                            <div className="error-text">{lectureFormik.errors.videoYoutube}</div>
                                        )}
                                    </div>

                                    <div className="mb-5 studentfield">
                                        <label
                                            htmlFor="duration"
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Duration *
                                        </label>
                                        <div className="duration-inputs flex gap-2">
                                            <div className="flex-1">
                                                <input
                                                    type="number"
                                                    id="durationHours"
                                                    name="durationHours"
                                                    placeholder="0"
                                                    min="0"
                                                    max="99"
                                                    value={lectureFormik.values.durationHours || ''}
                                                    onChange={(e) => {
                                                        const hours = e.target.value;
                                                        const minutes = lectureFormik.values.durationMinutes || '0';
                                                        const seconds = lectureFormik.values.durationSeconds || '0';
                                                        // const totalSeconds = (parseInt(hours) * 3600) + (parseInt(minutes) * 60) + parseInt(seconds);
                                                        const formattedDuration = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
                                                        lectureFormik.setFieldValue('duration', formattedDuration);
                                                        lectureFormik.setFieldValue('durationHours', hours);
                                                    }}
                                                    onBlur={lectureFormik.handleBlur}
                                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 text-center"
                                                />
                                                <label className="block text-xs text-gray-500 mt-1 text-center">Hours</label>
                                            </div>
                                            <div className="flex items-center text-gray-500 font-bold">:</div>
                                            <div className="flex-1">
                                                <input
                                                    type="number"
                                                    id="durationMinutes"
                                                    name="durationMinutes"
                                                    placeholder="0"
                                                    min="0"
                                                    max="59"
                                                    value={lectureFormik.values.durationMinutes || ''}
                                                    onChange={(e) => {
                                                        const minutes = e.target.value;
                                                        const hours = lectureFormik.values.durationHours || '0';
                                                        const seconds = lectureFormik.values.durationSeconds || '0';
                                                        // const totalSeconds = (parseInt(hours) * 3600) + (parseInt(minutes) * 60) + parseInt(seconds);
                                                        const formattedDuration = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
                                                        lectureFormik.setFieldValue('duration', formattedDuration);
                                                        lectureFormik.setFieldValue('durationMinutes', minutes);
                                                    }}
                                                    onBlur={lectureFormik.handleBlur}
                                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 text-center"
                                                />
                                                <label className="block text-xs text-gray-500 mt-1 text-center">Minutes</label>
                                            </div>
                                            <div className="flex items-center text-gray-500 font-bold">:</div>
                                            <div className="flex-1">
                                                <input
                                                    type="number"
                                                    id="durationSeconds"
                                                    name="durationSeconds"
                                                    placeholder="0"
                                                    min="0"
                                                    max="59"
                                                    value={lectureFormik.values.durationSeconds || ''}
                                                    onChange={(e) => {
                                                        const seconds = e.target.value;
                                                        const hours = lectureFormik.values.durationHours || '0';
                                                        const minutes = lectureFormik.values.durationMinutes || '0';
                                                        // const totalSeconds = (parseInt(hours) * 3600) + (parseInt(minutes) * 60) + parseInt(seconds);
                                                        const formattedDuration = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
                                                        lectureFormik.setFieldValue('duration', formattedDuration);
                                                        lectureFormik.setFieldValue('durationSeconds', seconds);
                                                    }}
                                                    onBlur={lectureFormik.handleBlur}
                                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 text-center"
                                                />
                                                <label className="block text-xs text-gray-500 mt-1 text-center">Seconds</label>
                                            </div>
                                        </div>
                                        {lectureFormik.touched.duration && lectureFormik.errors.duration && (
                                            <div className="error-text">{lectureFormik.errors.duration}</div>
                                        )}
                                    </div>

                                    <div className="mb-5 studentfield">
                                        <label
                                            htmlFor="accountId"
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Host Account *
                                        </label>
                                        <select
                                            id="accountId"
                                            name="accountId"
                                            value={lectureFormik.values.accountId}
                                            onBlur={lectureFormik.handleBlur}
                                            onChange={lectureFormik.handleChange}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                            required
                                        >
                                            <option value="" disabled>
                                                Select an Account
                                            </option>
                                            {Accounts?.map((account) => (
                                                <option key={account.id} value={account.id}>
                                                    {account.accountName}
                                                </option>
                                            ))}
                                        </select>
                                        {lectureFormik.touched.accountId && lectureFormik.errors.accountId && (
                                            <div className="error-text">{lectureFormik.errors.accountId}</div>
                                        )}
                                    </div>

                                    <div className="mb-5 studentfield">
                                        <label
                                            htmlFor="videotype"
                                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Video Type *
                                        </label>
                                        <select
                                            id="videotype"
                                            name="videotype"
                                            value={lectureFormik.values.videotype}
                                            onBlur={lectureFormik.handleBlur}
                                            onChange={lectureFormik.handleChange}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                            required
                                        >
                                            <option value="youtube">YouTube Only</option>
                                            <option value="vimeo">Vimeo Only</option>
                                            <option value="both">Both (YouTube & Vimeo)</option>
                                        </select>
                                        {lectureFormik.touched.videotype && lectureFormik.errors.videotype && (
                                            <div className="error-text">{lectureFormik.errors.videotype}</div>
                                        )}
                                    </div>

                                    <div className="modal-actions">
                                        <button type="submit">Add Lecture</button>
                                        <button type="button" onClick={() => setShowAddLecture(false)}>Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {/* Edit Lecture Modal */}
                    {showEditLecture && (
                        <div className="modal" onClick={() => setShowEditLecture(false)}>
                            <div className="modal-content" onClick={e => e.stopPropagation()}>
                                <h3>Edit Lecture</h3>
                                <div className="form-tabs">
                                    <button
                                        className={`tab-button ${editModalTab === 'main' ? 'active' : ''}`}
                                        onClick={() => setEditModalTab('main')}
                                    >
                                        Main Settings
                                    </button>
                                    <button
                                        className={`tab-button ${editModalTab === 'quality' ? 'active' : ''}`}
                                        onClick={() => setEditModalTab('quality')}
                                    >
                                        Quality Settings
                                    </button>
                                </div>


                                <form onSubmit={editLectureFormik.handleSubmit}>
                                    <div className={`tab-content ${editModalTab === 'main' ? 'active' : ''}`}>
                                        <div className="mb-5 studentfield">
                                            <label
                                                htmlFor="title"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Lecture Title *
                                            </label>
                                            <input
                                                type="text"
                                                id="title"
                                                name="title"
                                                placeholder="Enter lecture title"
                                                value={editLectureFormik.values.title}
                                                onChange={editLectureFormik.handleChange}
                                                onBlur={editLectureFormik.handleBlur}
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                            />
                                            {editLectureFormik.touched.title && editLectureFormik.errors.title && (
                                                <div className="error-text">{editLectureFormik.errors.title}</div>
                                            )}
                                        </div>

                                        <div className="mb-5 studentfield">
                                            <label
                                                htmlFor="description"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Lecture Description *
                                            </label>
                                            <textarea
                                                id="description"
                                                name="description"
                                                placeholder="Enter lecture description"
                                                value={editLectureFormik.values.description}
                                                onChange={editLectureFormik.handleChange}
                                                onBlur={editLectureFormik.handleBlur}
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                                rows="3"
                                            />
                                            {editLectureFormik.touched.description && editLectureFormik.errors.description && (
                                                <div className="error-text">{editLectureFormik.errors.description}</div>
                                            )}
                                        </div>

                                        <div className="mb-5 studentfield">
                                            <label
                                                htmlFor="lecThumb"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Lecture Thumbnail
                                            </label>
                                            <input
                                                type="file"
                                                id="lecThumb"
                                                name="lecThumb"
                                                accept="image/*"
                                                onChange={e => editLectureFormik.setFieldValue('lecThumb', e.target.files[0])}
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                            />
                                        </div>

                                        <div className="mb-5 studentfield">
                                            <label
                                                htmlFor="lecVideo"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Vimeo URL
                                            </label>
                                            <input
                                                type="text"
                                                id="lecVideo"
                                                name="lecVideo"
                                                placeholder="Enter Vimeo video URL"
                                                value={editLectureFormik.values.lecVideo}
                                                onChange={editLectureFormik.handleChange}
                                                onBlur={editLectureFormik.handleBlur}
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                            />
                                            {editLectureFormik.touched.lecVideo && editLectureFormik.errors.lecVideo && (
                                                <div className="error-text">{editLectureFormik.errors.lecVideo}</div>
                                            )}
                                        </div>

                                        <div className="mb-5 studentfield">
                                            <label
                                                htmlFor="videoYoutube"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                YouTube Video URL
                                            </label>
                                            <input
                                                type="text"
                                                id="videoYoutube"
                                                name="videoYoutube"
                                                placeholder="Enter YouTube video URL"
                                                value={editLectureFormik.values.videoYoutube}
                                                onChange={editLectureFormik.handleChange}
                                                onBlur={editLectureFormik.handleBlur}
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                            />
                                            {editLectureFormik.touched.videoYoutube && editLectureFormik.errors.videoYoutube && (
                                                <div className="error-text">{editLectureFormik.errors.videoYoutube}</div>
                                            )}
                                        </div>

                                        <div className="mb-5 studentfield">
                                            <label
                                                htmlFor="duration"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Duration *
                                            </label>
                                            <div className="duration-inputs flex gap-2">
                                                <div className="flex-1">
                                                    <input
                                                        type="number"
                                                        id="editDurationHours"
                                                        name="editDurationHours"
                                                        placeholder="0"
                                                        min="0"
                                                        max="99"
                                                        value={editLectureFormik.values.editDurationHours || ''}
                                                        onChange={(e) => {
                                                            const hours = e.target.value;
                                                            const minutes = editLectureFormik.values.editDurationMinutes || '0';
                                                            const seconds = editLectureFormik.values.editDurationSeconds || '0';
                                                            const formattedDuration = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
                                                            editLectureFormik.setFieldValue('duration', formattedDuration);
                                                            editLectureFormik.setFieldValue('editDurationHours', hours);
                                                        }}
                                                        onBlur={editLectureFormik.handleBlur}
                                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 text-center"
                                                    />
                                                    <label className="block text-xs text-gray-500 mt-1 text-center">Hours</label>
                                                </div>
                                                <div className="flex items-center text-gray-500 font-bold">:</div>
                                                <div className="flex-1">
                                                    <input
                                                        type="number"
                                                        id="editDurationMinutes"
                                                        name="editDurationMinutes"
                                                        placeholder="0"
                                                        min="0"
                                                        max="59"
                                                        value={editLectureFormik.values.editDurationMinutes || ''}
                                                        onChange={(e) => {
                                                            const minutes = e.target.value;
                                                            const hours = editLectureFormik.values.editDurationHours || '0';
                                                            const seconds = editLectureFormik.values.editDurationSeconds || '0';
                                                            const formattedDuration = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
                                                            editLectureFormik.setFieldValue('duration', formattedDuration);
                                                            editLectureFormik.setFieldValue('editDurationMinutes', minutes);
                                                        }}
                                                        onBlur={editLectureFormik.handleBlur}
                                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 text-center"
                                                    />
                                                    <label className="block text-xs text-gray-500 mt-1 text-center">Minutes</label>
                                                </div>
                                                <div className="flex items-center text-gray-500 font-bold">:</div>
                                                <div className="flex-1">
                                                    <input
                                                        type="number"
                                                        id="editDurationSeconds"
                                                        name="editDurationSeconds"
                                                        placeholder="0"
                                                        min="0"
                                                        max="59"
                                                        value={editLectureFormik.values.editDurationSeconds || ''}
                                                        onChange={(e) => {
                                                            const seconds = e.target.value;
                                                            const hours = editLectureFormik.values.editDurationHours || '0';
                                                            const minutes = editLectureFormik.values.editDurationMinutes || '0';
                                                            const formattedDuration = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
                                                            editLectureFormik.setFieldValue('duration', formattedDuration);
                                                            editLectureFormik.setFieldValue('editDurationSeconds', seconds);
                                                        }}
                                                        onBlur={editLectureFormik.handleBlur}
                                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 text-center"
                                                    />
                                                    <label className="block text-xs text-gray-500 mt-1 text-center">Seconds</label>
                                                </div>
                                            </div>
                                            {editLectureFormik.touched.duration && editLectureFormik.errors.duration && (
                                                <div className="error-text">{editLectureFormik.errors.duration}</div>
                                            )}
                                        </div>
                                        <div className="mb-5 studentfield">
                                            <label
                                                htmlFor="accountId"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Host Account
                                            </label>
                                            <select
                                                id="accountId"
                                                name="accountId"
                                                value={editLectureFormik.values.accountId}
                                                onBlur={editLectureFormik.handleBlur}
                                                onChange={editLectureFormik.handleChange}
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                                required
                                            >
                                                <option value="" disabled>
                                                    Select an Account
                                                </option>
                                                {Accounts?.map((account) => (
                                                    <option key={account.id} value={account.id}>
                                                        {account.accountName}
                                                    </option>
                                                ))}
                                            </select>
                                            {editLectureFormik.touched.accountId && editLectureFormik.errors.accountId && (
                                                <div className="error-text">{editLectureFormik.errors.accountId}</div>
                                            )}
                                        </div>

                                        <div className="mb-5 studentfield">
                                            <label
                                                htmlFor="videotype"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Video Type
                                            </label>
                                            <select
                                                id="videotype"
                                                name="videotype"
                                                value={editLectureFormik.values.videotype}
                                                onBlur={editLectureFormik.handleBlur}
                                                onChange={editLectureFormik.handleChange}
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                                required
                                            >
                                                <option value="youtube">YouTube Only</option>
                                                <option value="vimeo">Vimeo Only</option>
                                                <option value="both">Both (YouTube & Vimeo)</option>
                                            </select>
                                            {editLectureFormik.touched.videotype && editLectureFormik.errors.videotype && (
                                                <div className="error-text">{editLectureFormik.errors.videotype}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className={`tab-content ${editModalTab === 'quality' ? 'active' : ''}`}>
                                        <div className="quality-settings">
                                            <div className="quality-grid">
                                                <div className="quality-item">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            checked={qualitySettings.quality_240p}
                                                            onChange={() => handleQualityToggle(editLectureForm.id, 'quality_240p')}
                                                        />
                                                        240p
                                                    </label>
                                                </div>
                                                <div className="quality-item">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            checked={qualitySettings.quality_360p}
                                                            onChange={() => handleQualityToggle(editLectureForm.id, 'quality_360p')}
                                                        />
                                                        360p
                                                    </label>
                                                </div>
                                                <div className="quality-item">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            checked={qualitySettings.quality_480p}
                                                            onChange={() => handleQualityToggle(editLectureForm.id, 'quality_480p')}
                                                        />
                                                        480p
                                                    </label>
                                                </div>
                                                <div className="quality-item">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            checked={qualitySettings.quality_540p}
                                                            onChange={() => handleQualityToggle(editLectureForm.id, 'quality_540p')}
                                                        />
                                                        540p
                                                    </label>
                                                </div>
                                                <div className="quality-item">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            checked={qualitySettings.quality_720p}
                                                            onChange={() => handleQualityToggle(editLectureForm.id, 'quality_720p')}
                                                        />
                                                        720p
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-actions">
                                        <button type="submit">Save Changes</button>
                                        <button type="button" onClick={() => setShowEditLecture(false)}>Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {/* Section Edit Modal */}
                    {showEditSection && (
                        <div className="modal" onClick={() => setShowEditSection(false)}>
                            <div className="modal-content" onClick={e => e.stopPropagation()}>
                                <h3>Edit Section</h3>
                                <form onSubmit={editSectionFormik.handleSubmit}>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Section Name"
                                        value={editSectionFormik.values.name}
                                        onChange={editSectionFormik.handleChange}
                                        onBlur={editSectionFormik.handleBlur}
                                    />
                                    {editSectionFormik.touched.name && editSectionFormik.errors.name && (
                                        <div className="error">{editSectionFormik.errors.name}</div>
                                    )}
                                    <div className="modal-actions">
                                        <button type="submit">Save Changes</button>
                                        <button type="button" onClick={() => setShowEditSection(false)}>Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {/* Chapter Edit Modal */}
                    {showEditChapter && (
                        <div className="modal" onClick={() => setShowEditChapter(false)}>
                            <div className="modal-content" onClick={e => e.stopPropagation()}>
                                <h3>Edit Chapter</h3>
                                <form onSubmit={editChapterFormik.handleSubmit}>
                                    <input
                                        type="text"
                                        name="title"
                                        placeholder="Chapter Title"
                                        value={editChapterFormik.values.title}
                                        onChange={editChapterFormik.handleChange}
                                        onBlur={editChapterFormik.handleBlur}
                                    />
                                    {editChapterFormik.touched.title && editChapterFormik.errors.title && (
                                        <div className="error">{editChapterFormik.errors.title}</div>
                                    )}
                                    <div className="modal-actions">
                                        <button type="submit">Save Changes</button>
                                        <button type="button" onClick={() => setShowEditChapter(false)}>Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {/* Video Type Update Modal */}
                    {showVideoTypeModal && (
                        <div className="modal" onClick={() => setShowVideoTypeModal(false)}>
                            <div className="modal-content" onClick={e => e.stopPropagation()}>
                                <h3>Update Video Type</h3>
                                <p className="mb-4">
                                    Update video type for <strong>{selectedLectures.length}</strong> selected lecture(s)
                                </p>
                                <div className="mb-5 studentfield">
                                    <label htmlFor="videotype" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                        Video Type
                                    </label>
                                    <select
                                        id="videotype"
                                        value={videoTypeForm.videotype}
                                        onChange={(e) => setVideoTypeForm({ videotype: e.target.value })}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5"
                                    >
                                        <option value="youtube">YouTube Only</option>
                                        <option value="vimeo">Vimeo Only</option>
                                        <option value="both">Both (YouTube & Vimeo)</option>
                                    </select>
                                </div>
                                <div className="modal-actions">
                                    <button
                                        type="button"
                                        onClick={handleBulkUpdateVideoType}
                                        className="primary-btn"
                                    >
                                        Update Video Type
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setShowVideoTypeModal(false)}
                                        className="secondary-btn"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Table of Contents Modal */}
                    {showTableOfContents && (
                        <div className="modal toc-modal" onClick={() => setShowTableOfContents(false)}>
                            <div className="modal-content toc-content" onClick={e => e.stopPropagation()}>
                                <div className="toc-header">
                                    <h3>Course Index</h3>
                                    <button
                                        className="close-btn"
                                        onClick={() => setShowTableOfContents(false)}
                                    >
                                        ×
                                    </button>
                                </div>

                                <div className="course-stats">
                                    <div className="stat-item">
                                        <span className="stat-label">Sections:</span>
                                        <span className="stat-value">{getCourseStats().sections}</span>
                                    </div>
                                    <div className="stat-item">
                                        <span className="stat-label">Chapters:</span>
                                        <span className="stat-value">{getCourseStats().chapters}</span>
                                    </div>
                                    <div className="stat-item">
                                        <span className="stat-label">Lectures:</span>
                                        <span className="stat-value">{getCourseStats().lectures}</span>
                                    </div>
                                    <div className="stat-item">
                                        <span className="stat-label">Total Duration:</span>
                                        <span className="stat-value">{getCourseStats().totalDuration}</span>
                                    </div>
                                </div>

                                <div className="toc-content-scroll">
                                    {courseData.sections?.map((section, sectionIndex) => (
                                        <div key={section.id} className="toc-section">
                                            <div className="toc-section-header">
                                                <div className="toc-section-title" onClick={() => toggleTocSection(section.id)}>
                                                    {expandedTocSections[section.id] ? <MdExpandLess /> : <MdExpandMore />}
                                                    <MdViewList />
                                                    <span className="section-number">{sectionIndex + 1}.</span>
                                                    <span className="section-name">{section.name}</span>
                                                    <span className="section-count">
                                                        ({section.chapters?.length || 0} chapters)
                                                    </span>
                                                </div>
                                                <button
                                                    className="navigate-btn"
                                                    onClick={() => navigateToSection(section.id)}
                                                    title="Go to Section"
                                                >
                                                    <MdBook />
                                                </button>
                                            </div>

                                            {expandedTocSections[section.id] && section.chapters?.map((chapter, chapterIndex) => (
                                                <div key={chapter.id} className="toc-chapter">
                                                    <div className="toc-chapter-header">
                                                        <div className="toc-chapter-title" onClick={() => toggleTocChapter(chapter.id)}>
                                                            {expandedTocChapters[chapter.id] ? <MdExpandLess /> : <MdExpandMore />}
                                                            <MdFolderOpen />
                                                            <span className="chapter-number">{sectionIndex + 1}.{chapterIndex + 1}</span>
                                                            <span className="chapter-name">{chapter.title}</span>
                                                            <span className="chapter-count">
                                                                ({chapter.lectures?.length || 0} lectures)
                                                            </span>
                                                        </div>
                                                        <button
                                                            className="navigate-btn"
                                                            onClick={() => navigateToChapter(section.id, chapter.id)}
                                                            title="Go to Chapter"
                                                        >
                                                            <MdBook />
                                                        </button>
                                                    </div>

                                                    {expandedTocChapters[chapter.id] && chapter.lectures?.map((lecture, lectureIndex) => (
                                                        <div key={lecture.id} className="toc-lecture">
                                                            <div className="toc-lecture-content">
                                                                <MdPlayCircleFilled />
                                                                <span className="lecture-number">{sectionIndex + 1}.{chapterIndex + 1}.{lectureIndex + 1}</span>
                                                                <span className="lecture-name">{lecture.title}</span>
                                                                <span className="lecture-duration">{lecture.duration}</span>
                                                            </div>
                                                            <button
                                                                className="navigate-btn small"
                                                                onClick={() => navigateToLecture(section.id, chapter.id, lecture.id)}
                                                                title="Go to Lecture"
                                                            >
                                                                <MdBook />
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </>
            ) : activeTab === 'qbanks' ? (
                <CourseResources courseId={courseId} activeTab="qbanks" />
            ) : activeTab === 'files' ? (
                <CourseResources courseId={courseId} activeTab="files" />
            ) : activeTab === 'flashcards' ? (
                <CourseResources courseId={courseId} activeTab="flashcards" />
            ) : null}
            </div>
    );
};

// Main component that provides DnD context
const CourseContent = () => {
    const { courseId } = useParams();
    
    // Fetch course content using React Query
    const courseLectures = async () => {
        const token = localStorage.getItem('medtoken');
        let response = await axios.get(`${Baseurl}/admin/getCourse/${courseId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response?.data || {};
    };

    const { data: courseData = {}, refetch: courseRefetch, isLoading } = useQuery("courseLectures", courseLectures);

    if (isLoading) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <DndProvider backend={HTML5Backend}>
            <DnDProvider onDataChange={courseRefetch}>
                <CourseContentInner courseData={courseData} courseRefetch={courseRefetch} />
            </DnDProvider>
        </DndProvider>
    );
};

export default CourseContent; 